<script lang="ts">
  import { Eye, EyeOff } from '@lucide/svelte';
  import type { HTMLInputAttributes } from 'svelte/elements';
  import { cn } from '../lib/cn';
  import Input from './Input.svelte';

  /**
   * A password field with a show/hide toggle (ADR-033). Left-to-right like the phone: a password is
   * typed in any script but read as one string. The toggle sits on the left, where the text starts,
   * so the field pads that side (`ps` of a left-to-right input).
   */
  let {
    class: className,
    value = $bindable(),
    showLabel,
    hideLabel,
    ...rest
  }: Omit<HTMLInputAttributes, 'type'> & { showLabel: string; hideLabel: string } = $props();

  let visible = $state(false);
</script>

<div class="relative">
  <Input
    type={visible ? 'text' : 'password'}
    dir="ltr"
    autocapitalize="off"
    autocorrect="off"
    spellcheck={false}
    class={cn('pe-3 ps-11', className as string | undefined)}
    bind:value
    {...rest}
  />
  <button
    type="button"
    onclick={() => (visible = !visible)}
    aria-label={visible ? hideLabel : showLabel}
    aria-pressed={visible}
    class="absolute inset-y-0 end-0 flex w-11 items-center justify-center rounded-md text-text-3 hover:text-text"
  >
    {#if visible}<EyeOff class="size-4" aria-hidden="true" />{:else}<Eye class="size-4" aria-hidden="true" />{/if}
  </button>
</div>
